import { IWorkspaceDB } from "../interface/db";
import ILanguageDto from "../model/LanguageDto.if";
import ISiteDto from "../model/SiteDto.if";
import ITourDto from "../model/TourDto.if";

export function ToursForLanguage(db: IWorkspaceDB, language: ILanguageDto, site?: ISiteDto): Promise<Array<ITourDto>> {
    return new Promise(async function(resolve, reject) {
        try {
            /* to get the list of tours we can show based on the language selected we need ITourDto.tourSupportedLanguage.siteSupportedLanguage.language === language */
            const sslMatch = await db.siteSupportedLanguage().all().then(ssl => ssl.filter(x => x.languageId === language.id))
            const sslMatchIds = sslMatch.map(x => x.id);

            const tslMatch = await db.tourSupportedLanguage().all().then((tsl)=>tsl.filter(x => sslMatchIds.includes(x.siteSupportedLanguageId)));
            const tslMatchTourIds = tslMatch.map(x => x.tourId);

            const tours: ITourDto[] = await db.tour().all().then(tours => tours.filter(tour => tslMatchTourIds.includes(tour.id)));

            resolve(tours);
        } catch (error) {
            reject(error);
        }
    })
}

const exports = {
    ToursForLanguage
}

export default exports
